import React from "react";
import ProfileDataList from "./ProfileDataList";
import { Tag, Skeleton } from "antd";
import "./ProfileData.scss";
import { useTranslation } from "react-i18next";

function filterUniqueAgents(agents) {
    const idsMap = new Map();
    return agents.reduce((result, agent) => {
        if (agent?.assistantUser?.id) {
            if (!idsMap.has(agent.assistantUser.id)) {
                idsMap.set(agent.assistantUser.id, true);
                result.push(agent);
            }
        } else {
            result.push(agent);
        }
        return result;
    }, []);
}

function ProfileData({ agents, customer, customerFields, isLoading }) {
    const { t } = useTranslation();
    const uniqueAgents = agents ? filterUniqueAgents(agents) : undefined;

    return (
        <div className="profile-box">
            {isLoading ? (
                <Skeleton active />
            ) : (
                <>
                    <ProfileDataList customer={customer} customerFields={customerFields} />
                    {uniqueAgents && (
                        <div>
                            <div style={{ width: "100%", marginBottom: "10px" }}>
                                <p className="opt-subtitle" style={{ marginBottom: "6px" }}>
                                    {t("agents")}
                                </p>

                                {uniqueAgents.map(
                                    (agent) =>
                                        agent.type === "ASSISTANT" &&
                                        agent.assistantUser && (
                                            <Tag key={agent.assistantUser.id} color="blue">
                                                {agent.assistantUser.email}
                                            </Tag>
                                        )
                                )}
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
export default ProfileData;
